import { render, staticRenderFns } from "./WonderAiReportDetail.vue?vue&type=template&id=a17e598c&scoped=true"
import script from "./WonderAiReportDetail.vue?vue&type=script&lang=js"
export * from "./WonderAiReportDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderAiReportDetail.vue?vue&type=style&index=0&id=a17e598c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17e598c",
  null
  
)

export default component.exports